import { ModuleContainer } from '@components/undock/modules'
import styled from '@emotion/styled'
import { mediaQueries } from '@lib/mediaQueries'

export const Container = styled(ModuleContainer)(
  mediaQueries({
    padding: ['2rem 0', '2rem 0', '3rem 0', '4rem 0', '6rem 0'],
  })
)

export const ContentWrapper = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  marginBottom: '4rem',
  width: '100%',
})

export const TestimonialsWrapper = styled.div({})
